import { BaseIcon } from './base';
import type { IconSmallProps } from './base';

export function IconGoogleSheets(props: IconSmallProps) {
  return (
    <BaseIcon {...props}>
      <path
        d="M14.3997 1.19982L19.7998 6.5999L17.0998 7.08951L14.3997 6.5999L13.9087 3.89986L14.3997 1.19982Z"
        fill="#188038"
      />
      <path
        d="M14.4014 6.59992V1.19984H5.5625C4.74889 1.19984 4.08936 1.85937 4.08936 2.67298V21.327C4.08936 22.1406 4.74889 22.8002 5.5625 22.8002H18.3254C19.139 22.8002 19.7986 22.1406 19.7986 21.327V6.59992H14.4014Z"
        fill="#34A853"
      />
      <path
        d="M7.03564 9.54472V16.6642H16.8552V9.54472H7.03564ZM11.3312 15.4358H8.26398V13.7179H11.3312V15.4358ZM11.3312 12.491H8.26398V10.7731H11.3312V12.491ZM15.6268 15.4358H12.5596V13.7179H15.6268V15.4358ZM15.6268 12.491H12.5596V10.7731H15.6268V12.491Z"
        fill="white"
      />
    </BaseIcon>
  );
}
